import Ajax from "./base";

// GoodFlip Live Sessions / board APIs — plain Ajax.encryptedRequest (no encrypt/decrypt)

export const ListBoardPosts = (params = {}) => {
  const qs = new URLSearchParams();
  if (params.status) qs.set("status", String(params.status));
  if (params.search) qs.set("search", String(params.search));
  if (params.page != null && params.page !== "") {
    qs.set("page", String(params.page));
  }
  if (params.limit != null && params.limit !== "") {
    qs.set("limit", String(params.limit));
  }
  const query = qs.toString();
  return Ajax.encryptedRequest(
    `/healthcoach/board/posts${query ? `?${query}` : ""}`,
    {
      method: Ajax.GET,
      withoutBody: true,
    }
  );
};

export const CreateBoardPost = (payload) => {
  return Ajax.encryptedRequest(`/healthcoach/board/posts`, {
    method: Ajax.POST,
    payload: payload,
  });
};

export const PatchBoardPost = (id, payload) => {
  return Ajax.encryptedRequest(`/healthcoach/board/posts/${id}`, {
    method: Ajax.PUT,
    payload,
  });
};

export const PublishBoardPost = (id) => {
  return Ajax.encryptedRequest(`/healthcoach/board/posts/${id}/publish`, {
    method: Ajax.POST,
    payload: {},
  });
};

export const CancelBoardPost = (id, payload) => {
  return Ajax.encryptedRequest(`/healthcoach/board/posts/${id}/cancel`, {
    method: Ajax.POST,
    payload: payload,
  });
};

export const DeleteBoardPost = (id) => {
  return Ajax.encryptedRequest(`/healthcoach/board/posts/${id}/delete`, {
    method: Ajax.POST,
    payload: {},
  });
};

export const ListBoardTopics = () => {
  return Ajax.encryptedRequest(`/healthcoach/board/topics`, {
    method: Ajax.GET,
    withoutBody: true,
  });
};

export const CreateBoardTopic = (payload) => {
  return Ajax.encryptedRequest(`/healthcoach/board/topics`, {
    method: Ajax.POST,
    payload: payload,
  });
};

export const ListBoardHosts = () => {
  return Ajax.encryptedRequest(`/healthcoach/board/hosts`, {
    method: Ajax.GET,
    withoutBody: true,
  });
};

export const CreateBoardHost = (payload) => {
  return Ajax.encryptedRequest(`/healthcoach/board/hosts`, {
    method: Ajax.POST,
    payload: payload,
  });
};

export const PatchBoardHost = (id, payload) => {
  return Ajax.encryptedRequest(`/healthcoach/board/hosts/${id}`, {
    method: Ajax.PUT,
    payload: payload,
  });
};

const boardApi = {
  ListBoardPosts,
  CreateBoardPost,
  PatchBoardPost,
  PublishBoardPost,
  CancelBoardPost,
  DeleteBoardPost,
  ListBoardTopics,
  CreateBoardTopic,
  ListBoardHosts,
  CreateBoardHost,
  PatchBoardHost,
};

export default boardApi;
